import { render, staticRenderFns } from "./Tipowallets.vue?vue&type=template&id=04f0e6e9&"
import script from "./Tipowallets.vue?vue&type=script&lang=js&"
export * from "./Tipowallets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports